import { useState } from 'react';

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
  </svg>
);
const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
);
const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
    <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="currentColor" stroke="none"/>
  </svg>
);

const links = {
  Estúdio: ['Sobre nós', 'Instrutores', 'Espaço', 'Blog', 'Carreiras'],
  Serviços: ['Yoga', 'Meditação', 'Massagem', 'Nutrição', 'Workshops'],
  Suporte: ['FAQ', 'Política de Privacidade', 'Termos de Uso', 'Contacto'],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setEmail('');
    setTimeout(() => setSubscribed(false), 4000);
  };

  return (
    <footer className="bg-ink text-white/80">
      <div className="max-w-6xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h2 className="font-playfair text-3xl text-white tracking-[0.3em] font-light mb-4">AURA</h2>
            <p className="font-dm text-sm text-white/50 leading-relaxed max-w-xs mb-6">
              Um espaço dedicado ao teu bem-estar, onde cada prática é uma jornada de autodescoberta e equilíbrio.
            </p>
            <div className="flex gap-3">
              {[InstagramIcon, FacebookIcon, YoutubeIcon].map((Icon, i) => (
                <button
                  key={i}
                  className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-sage hover:text-sage transition-all duration-200 cursor-pointer"
                  aria-label={['Instagram', 'Facebook', 'YouTube'][i]}
                >
                  <Icon />
                </button>
              ))}
            </div>
          </div>

          {/* Nav links */}
          {Object.entries(links).map(([title, items]) => (
            <div key={title}>
              <p className="font-dm text-xs tracking-[0.3em] text-sage uppercase mb-5">{title}</p>
              <ul className="space-y-3">
                {items.map((item) => (
                  <li key={item}>
                    <button
                      className="font-dm text-sm text-white/50 hover:text-white transition-colors duration-200 cursor-pointer text-left"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter */}
        <div className="border-t border-white/8 pt-10 mb-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <p className="font-playfair italic text-xl text-white mb-1">Recebe inspiração semanal</p>
              <p className="font-dm text-sm text-white/40">Dicas de bem-estar, horários e novidades do estúdio.</p>
            </div>
            <form onSubmit={handleSubscribe} className="flex gap-0 w-full md:w-auto">
              {subscribed ? (
                <p className="font-dm text-sm text-sage">Obrigado por subscrever! ✓</p>
              ) : (
                <>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="O teu email"
                    className="bg-white/5 border border-white/10 rounded-l-full px-5 py-2.5 font-dm text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-sage/50 w-60"
                  />
                  <button
                    type="submit"
                    className="bg-sage text-white px-5 py-2.5 rounded-r-full font-dm text-sm hover:bg-sage-dark transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    Subscrever
                  </button>
                </>
              )}
            </form>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-dm text-xs text-white/30">© 2024 AURA Wellness Studio. Todos os direitos reservados.</p>
          <p className="font-dm text-xs text-white/20">Lisboa, Portugal</p>
        </div>
      </div>
    </footer>
  );
}
